import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpClientModule} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Libro } from '../modelos/libro';
import { CartaResponse } from '../modelos/carta';
import { PermisoViajeResponse } from '../modelos/permisoviaje';
import { PoderResponse } from '../modelos/poder';
import { DomiciliarioResponse } from '../modelos/domiciliario';
import { SupervivenciaResponse } from '../modelos/supervivencia';

@Injectable({
    providedIn: 'root'
  })
  export class SupervivenciaService {
  
    
    httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
  
    constructor(private http:HttpClient) {
  
        
    }

    ObtenerPorCuid(Cuid:string ){

    return this.http.get<SupervivenciaResponse>(environment.URL_BACKEND + 'CertificadoSupervivencia/ObtenerPorCuid/'+Cuid)
        .pipe(
        retry(1),
        catchError(this.errorHandl)
        )

    }

    errorHandl(error) {
      let errorMessage = '';
      if(error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      console.log(errorMessage);
      return throwError(errorMessage);
    }
     


}